import { TApiSavedReport } from "@timenotes/shared/src/services/saved-reports/saved-reports-types"
import { SaveReportModal } from "./save-report-modal"
import { useState } from "react"
import { InPlaceEditDiv } from "components/base"
import { Badge, Button } from "antd"
import { toTitleCase } from "utils/string-utils"
import { LockOutlined, UserOutlined } from "@ant-design/icons"
import { SavedReportPage } from "../saved-report-page"

interface Props {
  savedReport: TApiSavedReport
}

const VISIBILITY_ICON_MAP = {
  admin: <LockOutlined />,
  private: <UserOutlined />
}

export const SavedReportTitle = (props: Props) => {
  const {
    savedReport
  } = props

  const [visible, setVisible] = useState(false)

  return (
    <>
      <div
        style={{
          display: 'flex',
          alignItems: 'start',
          gap: '10px',
          marginRight: '10px',
        }}
      >

        <InPlaceEditDiv
          style={{
            paddingTop: '0px',
            paddingBottom: '0px',

            paddingLeft: '10px',
            paddingRight: '10px',
            cursor: 'pointer',
          }}
          onClick={() => setVisible(true)}
        >
          <h1>
            {savedReport.name}
          </h1>
        </InPlaceEditDiv>

        <Button
          style={{
            marginTop: '10px',
          }}
          size="small"
          onClick={() => setVisible(true)}
          icon={VISIBILITY_ICON_MAP[savedReport.visibility]}
        >
          {toTitleCase(savedReport.visibility as string)} report
        </Button>

      </div>

      <SaveReportModal
        savedReport={{
          // explicitly pass partial attributes to not save filters if not desired at this point!
          id: savedReport.id,
          name: savedReport.name,
          description: savedReport.description,
          visibility: savedReport.visibility,
        }}

        visible={visible}
        onCancel={() => setVisible(false)}
      />
    </>
  )
}